import { MS_PER_DAY } from "@/lib/constants";
import { playyardSky } from "@/lib/playyardSky";
import { PlayyardSkyPhase } from "@/types";

// A night runs past midnight, so "tonight" is keyed to the date 12 hours ago.
const NIGHT_OFFSET_MS = MS_PER_DAY / 2;

export const playyardHalloween = {
  /** Bats, the ghost, wisps and the cauldron only come out after sunset. */
  isSpookyHour: (phase: PlayyardSkyPhase): boolean =>
    phase === PlayyardSkyPhase.BLUE_HOUR || phase === PlayyardSkyPhase.NIGHT,

  /**
   * Tonight's trick-or-treater: the same pet for every viewer all night,
   * picked fresh each evening.
   */
  getTrickOrTreaterId: (userIds: number[], now: number): number | null => {
    if (userIds.length === 0) return null;
    const nightIndex = Math.floor((now - NIGHT_OFFSET_MS) / MS_PER_DAY);
    const sortedIds = [...userIds].sort((left, right) => left - right);
    return sortedIds[
      Math.floor(playyardSky.random(nightIndex) * sortedIds.length)
    ];
  },
};
